import { h, Component } from 'preact';
import { animate, interpolate } from '../../helpers/utils/motion';
import Widget from '../components/Widget';
import Toast from '../components/Toast';
import './index.css';

export default class Desktop extends Component {
  constructor(props) {
    super(props);
    this.state = {
      display: null,
      isOpen: false,
      isFlashMode: false,
      flashEcm: null,
      bus: props.bus,
      ecmStorage: props.ecmStorage,
      updated: Date.now(),
      index: 1,
    };
  }

  componentDidMount() {
    this.props.setComponent(this);
  }

  addEcm = (ecm) => {
    const ecmNew = this.state.ecmStorage.create(ecm);
    this.setState({ updated: Date.now() });
    if (!ecmNew.seen) this._flash(ecmNew);
  };

  removeEcm = (ecm) => {
    this.setState((state) => {
      state.ecmStorage.delete(ecm.id);
      return { updated: Date.now() };
    });
  };

  onEcmClick = (ecm) => {
    this.props.bus.dispatch(ecm.ctaEvent, ecm);
  };

  onFlashEcmClick = (ecm) => {
    this.onEcmClick(ecm);
    this.onFlashEcmDismiss(ecm);
  };

  onFlashEcmDismiss = () => {
    this.setState({ flashEcm: null, isFlashMode: false });
  };

  onOpenWidget = () => {
    const { isOpen } = this.state;
    if (!isOpen) {
      this.setState(
        function (state) {
          state.ecmStorage.updateAll({ seen: true });
          return { isFlashMode: false, isOpen: true };
        },
        function () {
          animate({
            targets: Array.from(document.querySelectorAll('.ectomycorrhiza')).reverse(),
            duration: 400,
            easing: 'cubicInOut',
            styles: {
              transform: (t) => `translateY(${interpolate(40, 0, t)}px)`,
              opacity: (t) => `${interpolate(0, 1, t)}`,
            },
            stagger: 100,
          });
          // animate({
          //     targets: ".beans-snow-widget-component-icon-wrapper",
          //     duration: 400,
          //     easing: "quintOut",
          //     styles: {
          //         transform: t => `rotate(${interpolate(90, 270, t)}deg)`
          //     }
          // });
        }
      );
    } else {
      animate({
        targets: Array.from(document.querySelectorAll('.ectomycorrhiza')),
        duration: 400,
        easing: 'cubicInOut',
        styles: {
          transform: (t) => `translateY(${interpolate(40, 0, t)}px)`,
          opacity: (t) => `${interpolate(0, 1, t)}`,
        },
        stagger: 100,
        direction: 'reverse',
        onComplete: () => this.setState({ isOpen: false }),
      });
      // animate({
      //     targets: ".beans-snow-widget-component-icon-wrapper",
      //     duration: 400,
      //     easing: "quintOut",
      //     styles: {
      //         transform: t => `rotate(${interpolate(270, 90, t)}deg)`
      //     }
      // })
    }
  };

  _flash(ecm) {
    const { isFlashMode, isOpen } = this.state;
    if (isOpen) {
      ecm.seen = true;
      this.setState(function (state) {
        state.ecmStorage.update(ecm.id, ecm);
        return { updated: Date.now() };
      });
    }
    if (isFlashMode || isOpen) return;

    ecm.seen = true;
    this.setState(
      function (state) {
        state.ecmStorage.update(ecm.id, ecm);
        return { flashEcm: ecm, isFlashMode: true };
      },
      function () {
        animate({
          targets: '#ectomycorrhiza-flash',
          duration: 200,
          easing: 'cubicInOut',
          styles: {
            transform: (t) => `translateY(${interpolate(40, 0, t)}px)`,
            opacity: (t) => `${interpolate(0, 1, t)}`,
          },
        });
      }
    );
  }

  render() {
    const { display } = this.props;
    const { isFlashMode, isOpen, flashEcm, ecmStorage } = this.state;

    const ecmList = ecmStorage.all();
    const badge = ecmList.filter((ecm) => !ecm.seen).length;

    const color = display.color || '#0278D1';

    const position = display.h_position || 'left';

    const style = {
      zIndex: '2147483647',
      // marginBottom: display.v_margin,
      // marginLeft: display.h_margin
    };

    return (
      <div id="beans-snow-desktop-widget-container" style={style} className={position}>
        {!isFlashMode && isOpen ? (
          <div id="beans-snow-desktop-active-hub" style="display: flex; flex-direction: column; margin-bottom: 8px;">
            <div id="beans-snow-desktop-hub-container">
              <div id="beans-snow-desktop-hub-content">
                {ecmList.slice(0, 6).map((ecm, i) => {
                  return (
                    <Toast key={ecm.id} index={i} ecm={ecm} defaultColor={color} onClick={() => this.onEcmClick(ecm)} />
                  );
                })}
              </div>
            </div>
          </div>
        ) : null}
        {isFlashMode ? (
          <div id="beans-snow-desktop-active-hub" style="display: flex; flex-direction: column; margin-bottom: 8px;">
            <div id="beans-snow-desktop-hub-container">
              <div id="beans-snow-desktop-hub-content">
                <div id="ectomycorrhiza-flash">
                  <Toast
                    ecm={flashEcm}
                    index={0}
                    defaultColor={color}
                    onClick={() => this.onFlashEcmClick(flashEcm)}
                    onDismiss={() => this.onFlashEcmDismiss(flashEcm)}
                  />
                </div>
              </div>
            </div>
          </div>
        ) : null}
        <div id="beans-snow-desktop-widget-base">
          {badge > 0 ? <div id="beans-snow-desktop-badge">{badge}</div> : null}
          <Widget display={display} onClick={this.onOpenWidget} />
        </div>
      </div>
    );
  }
}
